import styled from "styled-components";

export const SOnboardingTemplatesModalName = styled.div`
  font-family: Inter;
  font-size: 40px;
  font-weight: 700;
  line-height: 52px;
  letter-spacing: -0.03em;
`;
